import { Buffer } from 'buffer';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import './css/main.css';
import { useAppSelector } from './hooks';
import { LoginPage } from './pages/LoginPage';
import { ClientsPage } from './pages/clients/ClientsPage';
import { ContactsPage } from './pages/contacts/ContactsPage';
import { RepairRequestsPage } from './pages/repair-requests/RepairRequestsPage';
import { CreateRepairRequestPage } from './pages/repair-requests/CreateRepairRequestPage';

import { CreateContactPage } from './pages/contacts/CreateContactPage';
import { MapPage } from './pages/map/MapPage';

function App() {

  const refreshToken = useAppSelector(state => state.user.refreshToken);
  // console.log("refreshToken: " + refreshToken);

  var tokenExpired = false;
  if (refreshToken) {
    const dateExpired = new Date(JSON.parse(Buffer.from(refreshToken.split(".")[1], 'base64').toString()).exp * 1000);
    tokenExpired = dateExpired < new Date() ? true : false;
  }
  // console.log("tokenExpired: " + tokenExpired);
  // console.log("refreshToken: " + refreshToken);
  if (tokenExpired || !refreshToken || refreshToken.length === 0) {
    // console.log("assss");
    // localStorage.setItem('accessToken', "");
    // localStorage.setItem('refreshToken', "");
    return (
      <LoginPage />
    )
  }

  return (
    <>
      <Header />
      <div className="main">
        <Routes>
          <Route path="/" element={<Navigate to="/requests" />}></Route>
          <Route path="requests" element={<RepairRequestsPage />}></Route>
          {/* <Route path="create-requests" element={<CreateRepairRequestPage />}></Route> */}
          <Route path="/request/:idRequest" element={<CreateRepairRequestPage />}></Route>
          <Route path="clients" element={<ClientsPage />}></Route>
          <Route path="map" element={<MapPage />}></Route>
          <Route path="contacts" element={<ContactsPage />}></Route>
          <Route path="/contacts/:idRequest" element={<CreateContactPage />}></Route>
        </Routes >
      </div >
    </>
  );
}

export default App;
